export default __webpack_public_path__ + "static/media/hypotenuse_logo_text_light.bfdd1e03.svg";